import { IconChevronRight } from "@tabler/icons-react";
import { type DataTableColumn } from "@/components/ui/data-table";
import { formatCurrency } from "@/lib/utils";
import type { TableRowData } from "@/data/types/breakdown.types";

export const columns: DataTableColumn<TableRowData>[] = [
  {
    id: 'featureName',
    header: 'Feature Name',
    accessorKey: 'group',
    flex: 1,
    enableSorting: false,
    cell: ({ row }) => {
      if (row.original.isTotal) {
        return <span className="font-bold">Total</span>;
      }
      return <span>{row.original.group}</span>;
    },
  },
  {
    id: 'totalCosts',
    header: 'Total Costs',
    accessorKey: 'totalCosts',
    align: 'left',
    flex: 1,
    cell: ({ row }) => {
      const costDistribution = row.original.costDistribution;
      const value = row.original.totalCosts;
      return (
        <span className={row.original.isTotal ? 'font-bold' : ''}>
          {formatCurrency(value, 6, 6)} ({costDistribution.toFixed(1)}%)
        </span>
      );
    },
  },
  {
    id: 'costPerAction',
    header: 'Cost per Action',
    accessorKey: 'costPerAction',
    align: 'left',
    flex: 1,
    cell: ({ row }) => {
      const costPerAction = row.original.costPerAction;
      return (
        <span className={row.original.isTotal ? 'font-bold' : ''}>
          {formatCurrency(costPerAction, 6, 6)}
        </span>
      );
    },
  },
  {
    id: 'totalEvents',
    header: 'Total Events',
    accessorKey: 'totalEvents',
    align: 'left',
    flex: 1,
    cell: ({ row }) => {
      const totalEvents = row.original.totalEvents;
      const distribution = row.original.eventDistribution;
      return (
        <span className={row.original.isTotal ? 'font-bold' : ''}>
          {totalEvents.toLocaleString()} ({distribution.toFixed(1)}%)
        </span>
      );
    },
  },
  {
    id: 'dayAverage',
    header: 'Day Average',
    accessorKey: 'dayAverage',
    align: 'left',
    flex: 1,
    cell: ({ row, getValue }) => {
      const value = getValue() as number;
      return (
        <span className={row.original.isTotal ? 'font-bold' : ''}>
          {formatCurrency(value, 6, 6)}
        </span>
      );
    },
  },
  {
    id: 'actions',
    header: '',
    flex: 0.3,
    enableSorting: false,
    cell: ({ row }) => {
      if (row.original.isTotal) return null;
      return (
        <div className="flex items-center justify-end">
          <IconChevronRight className="size-4 text-[#8A8F98]" />
        </div>
      );
    },
  },
];